// CookieContext.js
import { createContext, useState, useEffect } from "react";

export const CookieContext = createContext();

const defaultConsent = {
  necessary: true, // zawsze true (wymagane)
  analytics: false,
  marketing: false,
};

export const CookieProvider = ({ children }) => {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem("cookieConsent");
    if (saved) {
      setConsent(JSON.parse(saved));
    }
  }, []);

  const saveConsent = (data) => {
    const fullConsent = { ...defaultConsent, ...data };
    localStorage.setItem("cookieConsent", JSON.stringify(fullConsent));
    setConsent(fullConsent);
  };

  return (
    <CookieContext.Provider value={{ consent, saveConsent }}>
      {children}
    </CookieContext.Provider>
  );
};
